<template>
	<div class="row">
		<div class="container pb-6">
			<div class="row d-flex justify-content-center align-items-center my-4">
				<div class="col-12 items-contain d-flex ml-auto">
					<div class="items-contain d-none d-xl-flex flex-wrap justify-content-center align-items-center w-100 mr-4">
						<button class="btn btn-primary btn-hover-up text-uppercase" @click.stop.prevent="setCategory()">All</button>
						<template v-for="(category,index) in categories">
							<span class="prefix" :key="category.ID" v-if="index >= 0">
								/
							</span>
							<div class="button-with-prefix d-flex align-items-center" :key="category.ID">
								<button class="btn btn-primary btn-hover-up text-uppercase" @click.prevent.stop="setCategory(category.ID)">{{category.name}}</button>
								<!-- <span class="btn text-uppercase">{{category.name}}</span> -->
							</div>
						</template>
					</div>
					<div class="mode-controller d-flex ml-auto align-items-center">
						<div class="grid-icon mr-3" style="cursor:pointer;" @click.stop.prevent="setMode('grid')">
							<svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Work-Landing-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="grid-icon-g" transform="translate(-1312.000000, -610.000000)" :stroke="mode == 'grid' ? '#FFE261' : '#121212'" stroke-width="2">
										<g id="Grid/List" transform="translate(1312.000000, 610.000000)">
											<g id="Group-3-Copy">
												<rect id="Rectangle" x="1" y="1" width="11" height="11"></rect>
												<rect id="Rectangle-Copy-2" x="18" y="1" width="11" height="11"></rect>
												<rect id="Rectangle-Copy-3" x="18" y="18" width="11" height="11"></rect>
												<rect id="Rectangle-Copy-4" x="1" y="18" width="11" height="11"></rect>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</div>
						<div class="list-icon mx-auto align-items-center" style="cursor:pointer;" @click.stop.prevent="setMode('list')">
							<svg width="32px" height="27px" viewBox="0 0 32 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="other" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.75" stroke-linecap="square">
									<g id="list-icon-g" transform="translate(-1358.000000, -612.000000)" :stroke="mode == 'grid' ? '#121212' : '#FFE261'" stroke-width="2">
										<g id="g" transform="translate(1312.000000, 610.000000)">
											<g id="Group-4-Copy" transform="translate(47.000000, 3.000000)">
												<path d="M0,0.416666667 L30,0.416666667" id="Line-2"></path>
												<path d="M0,6.25 L30,6.25" id="Line-2-Copy"></path>
												<path d="M0,12.9166667 L30,12.9166667" id="Line-2-Copy-2"></path>
												<path d="M0,18.75 L30,18.75" id="Line-2-Copy-3"></path>
												<path d="M0,24.5833333 L30,24.5833333" id="Line-2-Copy-4"></path>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="mode == 'grid'">
				<div class="col-xl-3 col-lg-4 col-md-6 project mt-4 animated fadeInUp" v-for="project in projects" :key="project.ID" >
					<a :href="project.link" class="d-bloc h-100 w-100 link-unstyled">
						<div class="project-image h-100 w-100" :style="{backgroundImage: `url(${project.thumbnail})`, backgroundSize: `cover`, backgroundPosition: `center`}" tabindex="0">
							<div class="project-overlay d-flex justify-content-center align-items-center flex-column w-100 h-100">
								<span class="project-title" v-html="project.post_title">
									<!-- {{project.post_title}} -->
								</span>
								<span class="text-center pt-3 text-black">{{project.project_location}}</span>

							</div>
						</div>
					</a>
				</div>
			</div>
			<div class="row project-list-view" v-else>
				<a :href="project.link" class="col-10 mx-auto project-list-item" v-for="project in projects" :key="project.ID">
					<div class="row d-none d-md-flex">
						<div class="col-12 col-xl-2 project-img" :style="{backgroundImage: `url(${project.thumbnail})`, backgroundSize: `cover`, backgroundPosition: `center`}" aria-hidden="true">
						</div>
						<div class="col-12 col-xl-3 project-title d-flex align-items-center pt-3 pt-xl-0" v-html="project.post_title">
							<!-- {{project.post_title}} -->
						</div>
						<div class="col-12 col-xl-2 project-category d-flex align-items-center pt-1 pt-xl-0">
							{{(project.categories[0] || {name: ''}).name}}
						</div>
						<div class="col-12 col-xl-5 d-flex align-items-center py-3">
							{{project.project_description}}
						</div>
					</div>
					<!-- Mobile Layout -->
					<div class="row d-flex d-md-none">
						<div class="col-12 project-img" :style="{backgroundImage: `url(${project.thumbnail})`, backgroundSize: `cover`, backgroundPosition: `center`}" aria-hidden="true">
						</div>
						<div class="col-12">
							<div class="project-title d-flex align-items-center" v-html="project.post_title">
								<!-- {{project.post_title}} -->
							</div>
							<div class="project-category d-flex align-items-center">
								{{(project.categories[0] || {name: ''}).name}}
							</div>
						</div>
					</div>
					<div class="row d-flex d-md-none">
						<div class="col-12 d-flex align-items-center py-3">
								{{project.project_description}}
						</div>
					</div>
				</a>
			</div>
			<div class="row" v-show="loading">
				<div class="col-12 d-flex justify-content-center align-items-center my-4">
					<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
					<span class="loading-text">Loading more projects...</span>
				</div>
			</div>
			<div class="row" v-show="!loading && mightHaveMoreLocations">
				<div class="col-12 d-flex justify-content-center pt-4">
					<button class="btn btn-primary btn-hover-up text-uppercase" @click.stop.prevent="loadMore()">
						Load More
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
const axios = require('axios');
export default {
	created(){
		console.info('projects created');
		this.getProjects();
		this.getProjectCategories();
	},
	mounted(){
		console.log('projects mounted');
	},
	methods: {
		getProjectRequest(categories = [], page = 0, take = 12){
			categories = categories[0] ? categories : [];
			return axios.get(`${this.api.prefix}${this.api.projects}?page=${page}&take=${take}&categories=${JSON.stringify(categories)}`);
		},
		getProjects(categories = [], page = 0, take = 12){
			this.$set(this, 'loading', true);
				this.getProjectRequest(categories, page, take)
				.then(projects => {
					this.$set(this, 'loading', false);
					this.$set(this, 'mightHaveMoreLocations', projects.data.length == take);
					this.delayedInsert(this.projects, projects.data);
				}).catch(err => {
					this.$set(this, 'loading', false);
					this.$set(this, 'mightHaveMoreLocations', false);
				});
		},
		getProjectCategories(){
			axios.get(`${this.api.prefix}${this.api.projectCategories}`).then( response => {
				const projectCategories = response.data;
				this.$set(this, 'categories', projectCategories);
			} );
		},
		loadMore(){
			this.$set(this, 'page', this.page + 1);
			this.getProjects([this.category], this.page);
		},
		setCategory(id){
			this.$set(this, 'category', id);
			this.$set(this, 'page', 0);
			this.$set(this, 'loading', true);
			this.getProjectRequest([this.category]).then(response => {
				this.$set(this, 'loading', false);
				// this.$set(this, 'projects', []);
				// this.delayedInsert(this.projects, response.data);
				this.$set(this, 'projects', response.data);
			});
		},
		delayedInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedInsert(subject, rest);
				}, 200);
			}
		},
		setMode(mode){
			this.$set(this, 'mode', mode);
		},
		json(j){
			return JSON.stringify(j);
		}
	},
	data() {
		return {
			projects: [],
			categories: [],
			category: null,
			mightHaveMoreLocations: true,
			loading: true,
			api: {
				prefix: '/wp-json/kbso/v1/',
				projects: 'projects/',
				projectCategories: 'projects/categories/',
			},
			page: 0,
			//Can be "grid" or "table"
			mode: 'grid'
		};
	}
}
</script>
